// extracted by css-extract-rspack-plugin
export default {"section":"section-GjPe0A","checkbox":"checkbox-I9r93x"};